export const ADD_THEME_LESSONS = 'add_theme_lesson';
export const UPDATE_BUILDING_HW_ASSIGNMENT = 'update_building_hw_assignment'
export const RESET_HOMEWORK_ASSIGNMENT = 'reset_homework_assignment'
export const SET_HW_CREATED_ASSIGNMENTS = 'set_hw_created_assignments'
export const ADD_ASSIGNMENT_LIBRARY = 'add_assignment_library'
export const SET_CURRENT_ASSIGNMENT = 'set_current_assignment'
export const RESET_ASSIGNMENT_LIBRARY = 'reset_assignment_library'
export const ADD_THEME_LESSONS_TOPIC = 'add_theme_lessons_topics'
export const ADD_CATEGORY_TOPICS = 'add_category_topics'
export const ADD_BOOK_LESSONS = 'add_book_lessons'
